export const CRM_TICKET_CATEGORIES = [
  { value: 'bug', label: 'Bug' },
  { value: 'feature_request', label: 'Feature Request' },
  { value: 'school_support', label: 'School Support' },
  { value: 'crm_task', label: 'CRM Task' },
  { value: 'technical_issue', label: 'Technical Issue' },
  { value: 'payment_issue', label: 'Payment Issue' },
  { value: 'data_correction', label: 'Data Correction' },
  { value: 'ui_ux', label: 'UI/UX' },
  { value: 'other', label: 'Other' },
];

export const CRM_TICKET_PRIORITIES = [
  { value: 'low', label: 'Low', color: 'bg-slate-100 text-slate-700' },
  { value: 'medium', label: 'Medium', color: 'bg-blue-100 text-blue-700' },
  { value: 'high', label: 'High', color: 'bg-amber-100 text-amber-800' },
  { value: 'critical', label: 'Critical', color: 'bg-red-100 text-red-700' },
];

export const CRM_TICKET_STATUS_COLORS = {
  open: 'bg-blue-100 text-blue-800',
  assigned: 'bg-violet-100 text-violet-800',
  in_progress: 'bg-amber-100 text-amber-800',
  waiting_for_customer: 'bg-cyan-100 text-cyan-800',
  testing: 'bg-pink-100 text-pink-800',
  completed: 'bg-green-100 text-green-800',
  closed: 'bg-gray-100 text-gray-700',
  cancelled: 'bg-red-100 text-red-700',
};

export function ticketCategoryLabel(value) {
  return CRM_TICKET_CATEGORIES.find((c) => c.value === value)?.label || value || 'Other';
}

export function ticketPriorityLabel(value) {
  return CRM_TICKET_PRIORITIES.find((p) => p.value === value)?.label || value || 'Medium';
}

export function ticketPriorityClass(value) {
  return CRM_TICKET_PRIORITIES.find((p) => p.value === value)?.color || 'bg-slate-100 text-slate-700';
}

export function ticketStatusLabel(status, statuses = []) {
  const found = statuses.find((s) => s.slug === status);
  if (found) return found.label;
  return (status || '').replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

export function ticketStatusClass(status) {
  return CRM_TICKET_STATUS_COLORS[status] || 'bg-slate-100 text-slate-700';
}

export function formatSlaRemaining(seconds) {
  if (seconds == null) return null;
  const abs = Math.abs(seconds);
  const days = Math.floor(abs / 86400);
  const hours = Math.floor((abs % 86400) / 3600);
  const prefix = seconds < 0 ? 'Overdue by ' : '';
  if (days > 0) return `${prefix}${days}d ${hours}h`;
  if (hours > 0) return `${prefix}${hours}h`;
  return `${prefix}${Math.floor(abs / 60)}m`;
}
